import { ShakerIcon } from './ShakerIcon';

/**
 * author: Michael Irigoyen
 * id 4E49931C-2FF9-4957-942A-F2F0B8485E68
 * name shaker
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shaker.svg
 * tags
 * - Food / Drink 
 */
export const FishFoodIcon = ShakerIcon;
export default FishFoodIcon